export const AZIENDA_UID = "697b363c5416f";